import React, { useEffect, useState } from 'react'
import {
    Badge, Card, Container, Group, Indicator, SimpleGrid, Text, Title,
} from '@mantine/core'
import LoaderComponent from '../components/loader/LoaderComponent'
import { Link } from 'react-router-dom'
import '../index.css'


const DashBoardPage = () => {
    const [totalCount,    setTotalCount]    = useState({})
    const [machineStatus, setMachineStatus] = useState([])

    useEffect(() => {
        const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        const url = `${wsProtocol}//${window.location.host}/dashboardSocket/?user_id=${window.localStorage.getItem('userid')}`;
        const socket = new WebSocket(url);

        socket.onopen = () => {
            socket.send(JSON.stringify({
                message:   'CONNECTED',
                user_id:   window.localStorage.getItem('userid'),
                user_name: window.localStorage.getItem('username'),
            }));
        };

        socket.onmessage = (event) => {
            const b = JSON.parse(event.data);
            setTotalCount(b.total_count_result || {});

            // Sort: active machines first, then inactive
            const active   = [];
            const inactive = [];
            (b.machine_status || []).forEach((m) => {
                m.Machines_status === 'Inactive' ? inactive.push(m) : active.push(m);
            });
            setMachineStatus([...active, ...inactive]);
        };

        return () => socket.close();
    }, []);

    const hasLoaded = Object.entries(totalCount).length > 0;

    return (
        <Container mt="0.3rem" fluid>
            <Container fluid ml={10}>
                {!hasLoaded ? <LoaderComponent /> : (
                    <>
                        {/* ── Row 1: summary count cards ── */}
                        <SimpleGrid
                            cols={3}
                            breakpoints={[
                                { maxWidth: 'md', cols: 2 },
                                { maxWidth: 'sm', cols: 1 },
                            ]}
                        >
                            {Object.entries(totalCount).map(([key, value]) => (
                                <Card padding="lg" shadow="xs" radius="md" key={key}>
                                    <Group>
                                        <Text size="md" className="subcardHeading" style={{ marginBottom: '0.5rem' }}>
                                            {key}
                                        </Text>
                                        {key === 'Active Machines'   && <Indicator color="green" mt="-5px" />}
                                        {key === 'Inactive Machines' && <Indicator color="red"   mt="-5px" />}
                                    </Group>
                                    <Text color="var(--color-text)" weight={400} className="detailsCardcol1">
                                        {value}
                                    </Text>
                                </Card>
                            ))}
                        </SimpleGrid>

                        {/* ── Row 2: machine cards ── */}
                        <SimpleGrid
                            cols={3}
                            mt="lg"
                            breakpoints={[
                                { maxWidth: 'md', cols: 2 },
                                { maxWidth: 'sm', cols: 1 },
                            ]}
                        >
                            {machineStatus.map((machine) => {
                                const isActive = machine.Machines_status === 'Active';
                                const metrics  = machine.metrics || [];

                                return (
                                    <Card
                                        key={machine.node_id}
                                        padding="lg"
                                        shadow="xs"
                                        radius="md"
                                        style={{
                                            borderLeft: `4px solid ${isActive ? 'var(--mantine-color-green-6, #2f9e44)' : 'var(--mantine-color-red-6, #e03131)'}`,
                                        }}
                                    >
                                        {/* Machine name + status badge */}
                                        <Group position="apart" mb="xs" align="flex-start">
                                            <Link
                                                id="dashboardlink"
                                                to={`/app/submachine/${machine.Machine_name}/${machine.Machine_ID}`}
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <Title
                                                    order={5}
                                                    color="var(--color-bold-text)"
                                                    style={{ lineHeight: 1.3 }}
                                                >
                                                    {machine.Machine_name}
                                                </Title>
                                            </Link>
                                            <Badge
                                                color={isActive ? 'green' : 'red'}
                                                variant="light"
                                                size="sm"
                                            >
                                                {isActive ? 'Online' : 'Offline'}
                                            </Badge>
                                        </Group>

                                        {/* Today's metrics */}
                                        {metrics.length > 0 ? (
                                            <SimpleGrid cols={metrics.length === 1 ? 1 : 2} spacing="xs" mt="xs">
                                                {metrics.map((m, idx) => (
                                                    <div key={idx}>
                                                        <Text size="xs" color="dimmed" weight={500} mb={1}>
                                                            {m.name}
                                                        </Text>
                                                        <Text
                                                            size="sm"
                                                            color="var(--color-bold-text)"
                                                            weight={600}
                                                        >
                                                            {m.value ?? '—'}
                                                        </Text>
                                                    </div>
                                                ))}
                                            </SimpleGrid>
                                        ) : (
                                            <Text size="xs" color="dimmed" mt="xs">
                                                {isActive ? 'No metrics configured' : 'No data received today'}
                                            </Text>
                                        )}
                                    </Card>
                                );
                            })}
                        </SimpleGrid>
                    </>
                )}
            </Container>
        </Container>
    );
};

export default DashBoardPage;
